import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 17h5.3V1L.453 2.83A.7.7 0 000 3.483V17zm6 0h6.3V5L9 6.26V3.375a.7.7 0 00-.312-.583L6 1v16zm7 0h3V7.375a.7.7 0 00-.312-.583L13 5v12z" fill="#6B6E73" fillRule="evenodd" /></svg>);